import React, { ComponentType } from 'react'
import {
  Button,
  Grid,
  Header,
  Icon,
  Popup,
  Responsive
} from 'semantic-ui-react'
// Local
import {
  CONDITION,
  shouldRenderReskin2025
} from '../../../constant'
import If from '../../common/if'
import { EncounterConditionDisplay } from '../../authenticated/types'

const SafeHeader = Header as unknown as ComponentType<any>
const SafeGrid = Grid as unknown as ComponentType<any>

const popupContent = (
  prefix: string,
  conditions: EncounterConditionDisplay[]
): string => {
  if (conditions && conditions.length > 0) {
    const allOrNone = conditions.length === 1
      ? ' '
      : ' All '
    const conditionsSingularOrPlural = conditions.length === 1
      ? ' Condition'
      : ' Conditions'
    return `${prefix}${allOrNone}${conditions.length}${conditionsSingularOrPlural}`
  }
  return ''
}

type RenderWithToolbarProps = {
  conditions: any
  headerClassName: string
  onClickCollapseAll: (x: string, conditions: any) => void
  onClickExpandAll: (x: string, conditions: any) => void
  popupContentInternal: (x: string, conditions: any) => any
  title: string
}

function RenderWithToolbar(
  props: RenderWithToolbarProps
) {
  const {
    conditions,
    headerClassName,
    onClickCollapseAll,
    onClickExpandAll,
    popupContentInternal,
    title
  } = props
  const columnCount = conditions.length > 1
    ? 2
    : 1
  return (
    <SafeHeader
      attached="top"
      className={ headerClassName }
    >
      <SafeGrid columns={ columnCount }>
        <Grid.Column
          textAlign="left"
          verticalAlign="middle"
        >
          { title }
        </Grid.Column>
        <If isTrue={ conditions.length > 1 }>
          <Grid.Column textAlign="right">
            <span className="hover__hover">
              <Popup
                content={ popupContentInternal('Collapse', conditions) }
                trigger={
                  <Responsive
                    as={ Button }
                    icon basic
                    size="mini"
                    onClick={ onClickCollapseAll }
                  >
                    <Icon name="angle double up" />
                  </Responsive>
                } />
              <Popup
                content={ popupContentInternal('Expand', conditions) }
                trigger={
                  <Responsive
                    as={ Button }
                    icon
                    basic
                    size="mini"
                    onClick={ onClickExpandAll }
                  >
                    <Icon name="angle double down" />
                  </Responsive>
                } />
            </span>
          </Grid.Column>
        </If>
      </SafeGrid>
    </SafeHeader>
  )
}

type Props = {
  conditions: any[]
  displayIndex: number
  onAction?: (
    action: keyof typeof CONDITION.ACTION,
    conditions: EncounterConditionDisplay[] | string[]
  ) => void
  title: string
}

function ConditionHeader(props: Props) {
  const {
    conditions,
    displayIndex,
    onAction,
    title
  } = props

  const onClickExpandAll = () => {
    if (onAction) {
      onAction(
        CONDITION.ACTION.EXPAND_ALL,
        conditions
      )
    }
  }

  const onClickCollapseAll = () => {
    if (onAction) {
      onAction(
        CONDITION.ACTION.COLLAPSE_ALL,
        conditions
      )
    }
  }

  const shouldReskinClassName = shouldRenderReskin2025
    ? ' reskin'
    : ''

  // const headerClassName = displayIndex === 0
  //   ? 'conditions-address hover'
  //   : 'conditions-address additional hover'
  const headerClassName = 'conditions-address additional hover'

  const renderBasic = () => (
    <SafeHeader
      attached="top"
      className={ `${headerClassName}${shouldReskinClassName}` }
    >
      <span>
        { title }
      </span>
    </SafeHeader>
  )

  if (conditions && conditions.length > 1) {
    return (
      <RenderWithToolbar
        conditions={ conditions }
        headerClassName={ `${headerClassName}${shouldReskinClassName}` }
        onClickCollapseAll={ onClickCollapseAll }
        onClickExpandAll={ onClickExpandAll }
        popupContentInternal={ popupContent }
        title={ title }
      />
    )
  }
  return renderBasic()
}

export default ConditionHeader
